import classNames from 'classnames';
import s from './RadioButton.module.scss';
import VisualBox from '../shared/VisualBox';

type Props = {
  className?: string;
  id?: string;
  isChecked: boolean;
  disabled?: boolean;
  label: string;
  onChange: (newIsChecked: boolean) => void;
  size?: 'sm' | 'md';
};

const RadioButton: React.FC<Props> = ({
  className,
  disabled,
  id,
  isChecked,
  label,
  onChange,
  size = 'md',
}) => (
  <>
    <label className={classNames(s.container, size === 'md' && s.md, size === 'sm' && s.sm, className)}>
      <input
        type='radio'
        id={id}
        checked={isChecked}
        onChange={event => onChange(event.target.checked)}
        disabled={disabled}
      />
      <VisualBox isChecked={isChecked} size={size} style='round' />
      {label}
    </label>
  </>
);

export default RadioButton;
